/**
 * @fileoverview Collapsible content implementation for FAQ or similar sections
 * @description Implements an accordion-style collapsible content system with smooth animations
 */

(function () {
  /**
   * @function initCollapsibleContent
   * @description Initializes the collapsible content functionality
   *
   * This function:
   * 1. Finds all collapsible content toggles
   * 2. Adds click handlers for expanding/collapsing content
   * 3. Manages active states and animations
   *
   * @requires jQuery
   *
   * HTML Structure Expected:
   * - Elements with class "collapsible-content__toggle" for clickable headers
   * - Elements with class "collapsible-content__item" as parent containers
   * - Elements with class "collapsible-content__answer" for content sections
   * - Elements with class "collapsible-content__items" as the main container
   */
  const initCollapsibleContent = () => {
    $('.collapsible-content__toggle').each(function (index, element) {
      // Skip if already initialized
      if ($(this).hasClass('content_started')) {
        return '';
      }
      $(this).addClass('content_started');

      $(element).on('click', function () {
        const parent = $(this).parent();

        if (!parent.hasClass('active')) {
          // Handle opening a new section
          parent
            .siblings('.collapsible-content__item.active')
            .removeClass('active');
          parent.addClass('active');
          $(this)
            .closest('.collapsible-content__items')
            .find('.collapsible-content__answer')
            .stop()
            .slideUp(300);
          $(this).next().stop().slideDown(300);
        } else {
          // Handle closing the current section
          parent.removeClass('active');
          $(this).next().stop().slideUp(300);
        }
      });
    });
  };

  /**
   * @event shopify:section:load
   * @description Reinitializes collapsible content when Shopify section is loaded
   * This ensures functionality works in the theme editor
   */
  document.addEventListener('shopify:section:load', function () {
    initCollapsibleContent();
  });

  // Initial initialization
  initCollapsibleContent();
})();
